exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2noDylLw2E{font-size:9pt;display:inline-block;margin-left:5px;vertical-align:middle;color:#fff}@media (max-width:850px){._2noDylLw2E{display:block;margin-left:0;margin-top:5px}}", ""]);

// exports
exports.locals = {
	"label": "_2noDylLw2E"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/elements/ReviewAvgRating/ReviewAvgRating.scss
// module id = 973
// module chunks = 22